import hasher from 'object-hash'

export class Cache<T, H extends readonly unknown[] = readonly unknown[]> {
    private readonly cache = new Map<string, T>()

    constructor (private readonly hash: (hashable: H) => string = hasher) {}

    get (fetcher: () => T, ...hashable: H): T {
        /** Get hash key */
        const hash = this.hash(hashable)

        /** Use pre loaded or fetch */
        const cached = this.cache.has(hash) ? (this.cache.get(hash) as T) : fetcher()

        /** Store on cache */
        this.cache.set(hash, cached)

        return cached
    }
}
